import { render } from "./PortfolioEditPage.vue?vue&type=template&id=581bda5f&scoped=true"
import script from "./PortfolioEditPage.vue?vue&type=script&lang=js"
export * from "./PortfolioEditPage.vue?vue&type=script&lang=js"

import "./PortfolioEditPage.vue?vue&type=style&index=0&id=581bda5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581bda5f"]])

export default __exports__